import AppRouter from './routers';
import './App.scss';
import './styles/style.scss'
import { Provider } from 'react-redux';
import store from './redux/store';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  return (
    <Provider store={store()}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GG_APP_ID}>
        <AppRouter />
      </GoogleOAuthProvider>
    </Provider>
  );
}

export default App;
